import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestArticles from '@/pages/home/components/LatestArticles';
import Testimonials from '@/pages/home/components/Testimonials';
import StatsSection from '@/pages/home/components/StatsSection';
import CTASection from '@/pages/home/components/CTASection';
import FAQSection from '@/pages/home/components/FAQSection';

export default function Home() {
  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "51吃瓜爆料网 - 每日大瓜首发 | 网红黑料大全 | 热点事件深度揭秘",
    "description": "吃瓜爆料与51吃瓜爆料网联合运营，每日大瓜首发曝光。专注于网红黑料大全、明星翻车与热点事件深度揭秘。免费吃瓜社区。",
    "url": "https://www.chigua51.com",
    "isPartOf": {
      "@type": "WebSite",
      "name": "51吃瓜爆料网",
      "url": "https://www.chigua51.com",
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }} />
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryGrid />
        <LatestArticles />
        <Testimonials />
        <StatsSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}